export const ru = {
    trip_id_header: 'Командировка',
    execution_date_header: 'Дата оформления',
    cost_center_header: 'Центр затрат',
    person_header: 'Сотрудник',
    service_type_header: 'Услуга',
    service_type_value_avia: 'Авиабилет',
    service_type_value_hotel: 'Отель',
    service_type_value_rail: 'ЖД билет',
    service_type_value_transfer: 'Трансфер',
    service_type_value_vip_lounge: 'VIP-зал',
    service_type_value_fast_track: 'Fast track',
    service_type_value_aeroexpress: 'Аэроэкспресс',
    service_type_value_insurance: 'Страховка',
    service_type_value_additional: 'Дополнительная услуга',
    type_header: 'Тип транзакции',
    type_value_refund: 'Возврат',
    type_value_purchase: 'Покупка',
    type_value_exchange: 'Изменение',
    price_header: 'Цена услуги',
    fee_header: 'Сервисный сбор',
    full_price_header: 'Общая стоимость',
    status_header: 'Статус',
    status_value_completed: 'Отправлено в биллинг',
    status_value_verified: 'Сверено с реестром',
    status_value_paid: 'Оплачено',
    status_value_hold: 'Заморожено',
    is_penalty_header: 'Штраф',
};
